import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../query"
import { GetSearchUNCodesRequestQuery, SearchUNCodesResponseData } from "../types/order"
import api from "../client"

const getData = async (getSearchUNCodesRequestQuery: GetSearchUNCodesRequestQuery) => {

  const { code } = getSearchUNCodesRequestQuery

  try {
    const { data } = await api.get(`/un-codes/search/${code}`)
    return data
  } catch ({ response: { data } }) {
    return data
  }
}

export const useUNCodesSearch = (getSearchUNCodesRequestQuery: GetSearchUNCodesRequestQuery):
  QueryObserverBaseResult<SearchUNCodesResponseData> => {

  const { code, search } = getSearchUNCodesRequestQuery

  const { data, ...props } = useQuery<SearchUNCodesResponseData>(
    queryKeys.UN_CODES_SEARCH(getSearchUNCodesRequestQuery),
    () => getData(getSearchUNCodesRequestQuery),
    { enabled: Boolean(code) && search }
  )
  return { data, ...props }
}
